import { useMutation, useQueryClient } from "react-query";
import { submitEmpaForm } from "./gateway";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function useSubmitEmpaForm() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: submitEmpaForm,
    onSuccess: () => {
      enqueueSnackbar(t("Επιτυχής υποβολή της φόρμας!"), {
        variant: "success",
      });
      navigate("/business/dashboard");
    },
    onSettled: () => {
      queryClient.invalidateQueries("empaFormData");
    },
  });
}
